import { Box, BoxProps, Flex, FormLabel, Tooltip } from '@chakra-ui/react'
import React from 'react'
import { InfoOutlineIcon } from '@chakra-ui/icons'

interface IElementWithLabelProps extends BoxProps {
  children: React.ReactNode
  label: string
  required?: boolean
  isOptional?: boolean
  description?: string
  tooltip?: string
}

const ElementWithLabel = (props: IElementWithLabelProps) => {
  const {
    color,
    fontWeight,
    children,
    label,
    required,
    isOptional,
    description,
    tooltip,
    ...rest
  } = props
  return (
    <Box
      height='auto'
      display='flex'
      flexDirection='column'
      marginTop={'auto'}
      my={'0.3rem'}
      position={'relative'}
      {...rest}
      minWidth={'45%'}
    >
      {label ? (
        <FormLabel
          fontWeight={fontWeight ? fontWeight : ''}
          fontSize='md'
          color={color ? color : '#666666'}
        >
          <Flex alignItems={'center'}>
            <p>
              {label}
              {isOptional ? (
                <small
                  style={{
                    display: 'flex',
                    alignContent: 'center',
                    marginLeft: 2,
                  }}
                >
                  (Optional)
                </small>
              ) : null}
              {required ? <span style={{ color: 'red' }}>{' *'}</span> : ''}
              {tooltip ? (
                <Tooltip
                  label={tooltip}
                  marginLeft={1}
                  backgroundColor={'primary.50'}
                  color={'primary.500'}
                  fontWeight={'semibold'}
                  border='1px'
                  borderColor='primary.200'
                  rounded={4}
                >
                  <InfoOutlineIcon color='primary.500' cursor={'pointer'} marginLeft={1} />
                </Tooltip>
              ) : (
                ''
              )}
            </p>
          </Flex>
        </FormLabel>
      ) : null}

      {children}
    </Box>
  )
}

export { ElementWithLabel }
